<template>
  <div id="order-modal">
    <v-dialog :value="isModalActive" max-width="800" @input="inputModal">
      <v-card
        id="order-modal-card"
        class="pb-1"
        :color="$vuetify.theme.dark ? 'dark_backgroundDarkBlue' : undefined"
      >
        <v-card-title>
          <template v-if="myTypeOrderModal === 'switch' && subTypeOrderModal">
            {{ $t(`views.orders.orderModal.title.${myTypeOrderModal}.${subTypeOrderModal}`) }}
          </template>
          <template v-else>
            {{ myTypeOrderModal ? $t(`views.orders.orderModal.title.${myTypeOrderModal}`) : '' }}
          </template>
        </v-card-title>

        <v-card-text class="py-0 mb-0 mt-2">
          <ApiErrorAlert ref="apiErrorAlert" :error="errorCode" />

          <v-alert
            v-if="myTypeOrderModal === 'capitalIncrease' || myTypeOrderModal === 'scrip'"
            :color="$vuetify.theme.dark ? 'dark_backgroundSoftBlue' : 'softInfo'"
            icon="mdi-information"
            class="mt-4 py-3 pl-2 order-modal-card-capital-info"
          >
            <div v-if="myTypeOrderModal === 'capitalIncrease'">
              {{ $t(`views.orders.orderModal.capitalScripInfo.a`) }}
              <a @click="changeToMyTypeOrderModal('buy')">
                {{ $t(`views.orders.orderModal.capitalScripInfo.b`) }}
              </a>
            </div>

            <div>
              {{ $t(`views.orders.orderModal.capitalScripInfo.c-${myTypeOrderModal}`) }}
              <a
                href="https://www.filios.app/blog/como-tributa-un-scrip-dividend-el-lio-de-los-dividendos-flexibles-y-las-ampliaciones-de-capital/"
                target="_blank"
              >
                {{ $t(`views.orders.orderModal.capitalScripInfo.d`) }}
              </a>
              {{ $t(`views.orders.orderModal.capitalScripInfo.e`) }}
              <a href="https://www.filios.app/tutoriales/#tutorial6" target="_blank">
                {{ $t(`views.orders.orderModal.capitalScripInfo.f`) }}
              </a>
              {{ $t(`views.orders.orderModal.capitalScripInfo.g`) }}
            </div>
          </v-alert>

          <v-alert
            v-if="myTypeOrderModal === 'switch' && subTypeOrderModal === 'cash'"
            :color="$vuetify.theme.dark ? 'dark_backgroundSoftBlue' : 'softInfo'"
            icon="mdi-information"
            class="switch-cash-info-alert pa-2 mt-3 alert-cash-cripto"
          >
            {{ $t(`views.orders.orderModal.switchCashInfo.a`) }}{{ user.baseCurrency }}?
            {{ $t(`views.orders.orderModal.switchCashInfo.b`) }}
          </v-alert>

          <v-alert
            v-if="myTypeOrderModal === 'commission'"
            :color="$vuetify.theme.dark ? 'dark_backgroundSoftBlue' : 'softInfo'"
            icon="mdi-information"
            class="switch-cash-info-alert pa-2 mt-3 alert-cash-cripto"
          >
            {{ $t(`views.orders.orderModal.commissionAlert`) }}
          </v-alert>

          <v-alert
            v-if="myTypeOrderModal === 'spinOff'"
            :color="$vuetify.theme.dark ? 'dark_backgroundSoftBlue' : 'softInfo'"
            icon="mdi-information"
            class="switch-cash-info-alert pa-2 mt-3 alert-cash-cripto"
          >
            {{ $t(`views.orders.orderModal.spinOffAlert`) }}
          </v-alert>

          <v-row>
            <v-col v-if="showCreateNewPositionWithCard" cols="12" sm="5" xs="12">
              <div class="d-flex" :class="{ 'mb-3': isMobile }">
                <div>
                  <div v-if="positionSearchPositions && positionSearchPositions.length === 0">
                    {{ $t(`views.orders.orderModal.selectPosition.noPosition`) }}
                  </div>
                  <div v-else>
                    {{ $t(`views.orders.orderModal.selectPosition.title`) }}
                  </div>
                  <div
                    class="add-position-card mt-6 pa-5 pt-6"
                    @click="createNewPosition = !createNewPosition"
                  >
                    <v-icon size="18" color="primary">mdi-plus</v-icon>
                    <div class="mt-2">
                      {{ $t(`views.orders.orderModal.selectPosition.create`) }}
                    </div>
                  </div>
                </div>
                <v-divider v-show="!isMobile" vertical class="divider pl-6 mr-0 pr-0" />
              </div>
            </v-col>
            <v-col cols="12" :sm="showCreateNewPositionWithCard ? 7 : 12" xs="12" class="mt-0 pt-0">
              <div v-if="myTypeOrderModal === 'switch'" class="mb-0 pb-0">
                <p class="pa-0 mx-0 my-2">
                  {{
                    $t(`views.orders.orderModal.switch.switchPositionTitle.${subTypeOrderModal}`)
                  }}
                </p>
              </div>
              <div
                v-if="!editing && (createNewPosition || position)"
                :class="{ 'mb-4': !createNewPosition }"
              >
                <a class="go-back-link" @click="resetForm">
                  {{ $t(`views.orders.orderModal.createNewPosition.back`) }}
                </a>
              </div>
              <div>
                <PositionSearch
                  v-if="isModalActive && !createNewPosition"
                  ref="positionSearch"
                  v-model="position"
                  :positions.sync="positionSearchPositions"
                  :type="positionSearchType"
                  :showBaseCurrencyPosition="
                    [
                      'bonus',
                      'commission',
                      'paidInterest',
                      'interest',
                      'interestRetention',
                      'deposit',
                      'withdrawal',
                      'brokerTransfer',
                    ].indexOf(myTypeOrderModal) > -1
                  "
                  :disabled="loading || editing"
                />

                <div
                  v-if="showCreateNewPositionWithText"
                  class="order-modal-create-new-position mt-2"
                >
                  <a
                    v-if="
                      [
                        'buy',
                        'sell',
                        'bonus',
                        'stakeReward',
                        'drip',
                        'optionBuy',
                        'optionSell',
                        'commission',
                        'paidInterest',
                        'interest',
                        'interestRetention',
                        'deposit',
                        'withdrawal',
                      ].indexOf(myTypeOrderModal) > -1 && !editing
                    "
                    class="primary--text"
                    @click="createNewPosition = true"
                  >
                    {{ $t(`views.orders.orderModal.createNewPosition.activate`) }}
                  </a>
                </div>
              </div>
            </v-col>
          </v-row>

          <template v-if="createNewPosition">
            <PositionForm
              :position.sync="position"
              :loading="loading"
              :editing="editing"
              :positionTypesFilter="newPositionTypesFilter"
            />
          </template>

          <template v-if="position && position.type">
            <v-divider v-if="createNewPosition" class="mt-8 divider" />

            <v-row v-if="createNewPosition">
              <v-col cols="12" md="12" class="mb-0 pb-0">
                <h1 class="section-title mb-1 mt-5">
                  {{ $t(`views.orders.orderModal.createOrder.title`) }}
                </h1>
              </v-col>
            </v-row>
            <OrderForm
              :order.sync="order"
              :typeOrderModal="myTypeOrderModal"
              :position="position"
              :type="position.type"
              :typeOrDerivativeType="typeOrDerivativeType"
              :loading="loading"
              :editing="editing"
              :duplicating="duplicating"
              :showExchangeRate="showExchangeRate"
              :exchangeRatePair="exchangeRatePair"
              @rotateExchangeRatePair="rotateExchangeRatePair"
            />

            <v-card
              v-if="showPreviewCard"
              class="preview-card px-3 py-1 pt-2 mt-5 mb-0 elevation-0"
              :color="$vuetify.theme.dark ? 'dark_backgroundSoftBlue' : 'softBackgroundGrey'"
            >
              <h1>{{ $t(`views.orders.orderModal.previewOrder`) }}</h1>
              <v-progress-circular
                v-if="loadingDebouncePreview"
                size="15"
                width="1"
                indeterminate
                color="softTextGrey"
              ></v-progress-circular>
              <div v-else :class="{ 'items-flex': !isMobile }">
                <div class="items-flex">
                  <span class="mr-1">
                    <b>{{ $t('views.orders.ordersTable.total') }}</b>
                  </span>
                  <currency
                    v-if="preview.total"
                    :value="preview.total"
                    :currency="position.currency"
                    neverHide
                  />
                  <span v-else>-</span>
                </div>
                <div v-if="!isMobile" class="mx-3">|</div>
                <div class="items-flex">
                  <span class="mr-1">
                    <b>{{ $t('views.orders.ordersTable.total') }} ({{ user.baseCurrency }})</b>
                  </span>
                  <currency
                    v-if="preview.totalBaseCurrency"
                    :value="preview.totalBaseCurrency"
                    :currency="user.baseCurrency"
                    neverHide
                  />
                  <span v-else>-</span>
                </div>
                <div v-if="!isMobile" class="mx-3">|</div>
                <div class="items-flex">
                  <span class="mr-1">
                    <b>
                      {{ $t('views.orders.ordersTable.totalWithComission') }} ({{
                        user.baseCurrency
                      }})
                    </b>
                  </span>
                  <currency
                    v-if="preview.totalWithComissionBaseCurrency"
                    :value="preview.totalWithComissionBaseCurrency"
                    :currency="user.baseCurrency"
                    neverHide
                  />
                  <span v-else>-</span>
                </div>
              </div>
            </v-card>
          </template>
        </v-card-text>
        <v-card-actions class="mt-3">
          <v-spacer />
          <v-btn
            class="mr-1"
            text
            :disabled="loading"
            :small="$vuetify.breakpoint.smAndDown"
            @click="closeModal"
          >
            {{ $t('views.orders.orderModal.cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            :loading="loading"
            :disabled="saveDisabled"
            :small="$vuetify.breakpoint.smAndDown"
            @click="saveOrder"
          >
            {{ $t('views.orders.orderModal.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { pick, get } from 'lodash'
import { mapState } from 'vuex'
import gtag from '@/lib/gtag'
import { createPosition, createOrder, editOrder, deletePosition, previewOrder } from '@/lib/api.js'
import {
  getPositionTypes,
  getPositionOrDerivativePositionType,
  isPositionDerivative,
} from '@/lib/positions/positions.js'
import { OZT_TO_GR_RATE } from '@/lib/utils/math.js'
import modalMixin from '@/views/components/core/modalMixin.js'
import PositionModalMixin from '@/views/components/common/positions/PositionModalMixin'
import PositionForm from '@/views/components/common/positions/PositionForm'
import PositionSearch from '@/views/components/common/PositionSearch'
import ApiErrorAlert from '@/views/components/common/ApiErrorAlert'
import OrderForm from '@/views/components/common/orders/OrderForm'
import Currency from '@/views/components/common/Currency'

const ORDER_TYPES_AUTOSELECT_BASECURRENCY_POS = [
  'commission',
  'paidInterest',
  'interest',
  'interestRetention',
  'deposit',
  'withdrawal',
]

export default {
  components: { PositionForm, PositionSearch, ApiErrorAlert, OrderForm, Currency },
  mixins: [modalMixin, PositionModalMixin],
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    duplicating: {
      type: Boolean,
      default: false,
    },
    editItem: {
      type: Object,
      default: () => ({}),
    },
    typeOrderModal: {
      type: String,
      default: null,
    },
    subTypeOrderModal: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    myTypeOrderModal: null,
    order: null,
    loading: false,
    position: null,
    errorCode: null,
    createNewPosition: false,
    isPairRotated: false,
    positionSearchPositions: null,
    preview: {},
    debouncePreviewTimeout: null,
    loadingDebouncePreview: false,
  }),
  computed: {
    ...mapState(['user']),
    isMobile() {
      return this.$vuetify.breakpoint.xs
    },
    showCreateNewPosition() {
      return (
        this.positionSearchPositions &&
        [
          'buy',
          'sell',
          'bonus',
          'stakeReward',
          'drip',
          'optionBuy',
          'optionSell',
          'commission',
          'paidInterest',
          'interest',
          'interestRetention',
          'deposit',
          'withdrawal',
        ].indexOf(this.myTypeOrderModal) > -1 &&
        !this.editing &&
        !this.createNewPosition &&
        !this.position
      )
    },
    showCreateNewPositionWithCard() {
      return (
        this.showCreateNewPosition && (!this.isMobile || this.positionSearchPositions.length === 0)
      )
    },
    showCreateNewPositionWithText() {
      return (
        this.showCreateNewPosition && this.isMobile && this.positionSearchPositions.length !== 0
      )
    },
    showExchangeRate() {
      return this.position.currency !== this.user.baseCurrency
    },
    typeOrDerivativeType() {
      if (!this.position) return
      return getPositionOrDerivativePositionType(this.position)
    },
    showPreviewCard() {
      return ['split', 'brokerTransfer', 'spinOff'].indexOf(this.typeOrderModal) === -1
    },
    exchangeRatePair() {
      if (!this.showExchangeRate || !this.position.currency || !this.user.baseCurrency) return
      if (this.isPairRotated) {
        return `${this.user.baseCurrency}/${this.position.currency}`
      }
      return `${this.position.currency}/${this.user.baseCurrency}`
    },
    positionSearchType() {
      if (['buy', 'sell'].indexOf(this.myTypeOrderModal) > -1) {
        return getPositionTypes({ filterToHide: ['putOption', 'callOption'] })
      }
      if (this.myTypeOrderModal === 'switch') {
        if (this.subTypeOrderModal === 'fund') return ['fund', 'plan']
        else return ['cash', 'crypto']
      }
      if (
        ['sharePremium', 'scrip', 'capitalIncrease', 'spinOff'].indexOf(this.myTypeOrderModal) > -1
      ) {
        return ['stock', 'custom']
      }
      if (['stakeReward'].indexOf(this.myTypeOrderModal) > -1) {
        return ['cash', 'crypto', 'custom']
      }
      if (['optionBuy', 'optionSell'].indexOf(this.myTypeOrderModal) > -1) {
        return ['putOption', 'callOption']
      }
      if (
        [
          'commission',
          'paidInterest',
          'interest',
          'interestRetention',
          'deposit',
          'withdrawal',
        ].indexOf(this.myTypeOrderModal) > -1
      ) {
        return ['cash', 'crypto']
      }
      return null
    },
    newPositionTypesFilter() {
      if (['stakeReward'].indexOf(this.myTypeOrderModal) > -1) {
        return ['cash', 'crypto']
      }
      if (['optionBuy', 'optionSell'].indexOf(this.myTypeOrderModal) > -1) {
        return ['putOption', 'callOption']
      }
      if (
        [
          'commission',
          'paidInterest',
          'interest',
          'interestRetention',
          'deposit',
          'withdrawal',
        ].indexOf(this.myTypeOrderModal) > -1
      ) {
        return ['cash', 'crypto']
      }
      return getPositionTypes({ filterToHide: ['putOption', 'callOption'] })
    },
    saveDisabled() {
      const orderNotCompleted =
        !this.position ||
        !this.order.date ||
        ([
          'buy',
          'bonus',
          'stakeReward',
          'drip',
          'sell',
          'switch',
          'spinOff',
          'brokerTransfer',
          'sharePremium',
          'scrip',
          'capitalIncrease',
          'optionBuy',
          'optionSell',
          'commission',
          'paidInterest',
          'interest',
          'interestRetention',
          'deposit',
          'withdrawal',
        ].indexOf(this.myTypeOrderModal) > -1 &&
          !this.order.broker) ||
        ([
          'buy',
          'bonus',
          'stakeReward',
          'drip',
          'sell',
          'switch',
          'scrip',
          'capitalIncrease',
          'optionBuy',
          'optionSell',
        ].indexOf(this.myTypeOrderModal) > -1 &&
          this.order.customExchangeRate &&
          (!this.order.exchangeRate || this.order.exchangeRate <= 0)) ||
        (['switch'].indexOf(this.myTypeOrderModal) > -1 &&
          (!this.order.switch.switchBuyPosition ||
            !this.order.switch.switchBuyPositionNumber ||
            !this.order.switch.switchBuyBroker ||
            JSON.stringify(this.position) ===
              JSON.stringify(this.order.switch.switchBuyPosition))) ||
        (['spinOff'].indexOf(this.myTypeOrderModal) > -1 &&
          (!this.order.spinOff.spinOffBuyPosition ||
            !this.order.spinOff.spinOffBuyPositionNumber ||
            !this.order.spinOff.spinOffBuyPositionAllocation ||
            this.order.spinOff.spinOffBuyPositionAllocation > 100 ||
            this.order.spinOff.spinOffBuyPositionAllocation <= 0 ||
            JSON.stringify(this.position) ===
              JSON.stringify(this.order.spinOff.spinOffBuyPosition))) ||
        (['brokerTransfer'].indexOf(this.myTypeOrderModal) > -1 &&
          (!this.order.newBroker ||
            JSON.stringify(this.order.broker) === JSON.stringify(this.order.newBroker))) ||
        ([
          'buy',
          'bonus',
          'stakeReward',
          'drip',
          'sell',
          'switch',
          'split',
          'spinOff',
          'sharePremium',
          'scrip',
          'capitalIncrease',
          'optionBuy',
          'optionSell',
          'commission',
          'paidInterest',
          'interestRetention',
          'interest',
          'deposit',
          'withdrawal',
          'brokerTransfer',
        ].indexOf(this.myTypeOrderModal) > -1 &&
          !this.order.positionNumber) ||
        ([
          'buy',
          'bonus',
          'stakeReward',
          'drip',
          'sell',
          'switch',
          'split',
          'sharePremium',
          'scrip',
          'capitalIncrease',
          'optionBuy',
          'optionSell',
          'commission',
          'paidInterest',
          'interest',
          'interestRetention',
          'deposit',
          'withdrawal',
        ].indexOf(this.myTypeOrderModal) > -1 &&
          !this.order.price &&
          this.order.price !== 0 &&
          (this.position.type !== 'cash' || this.position.ticker !== this.user.baseCurrency))

      if (this.createNewPosition)
        return orderNotCompleted || this.positionNotCompleted(this.position)
      if (this.createNewSwitchBuyPosition)
        return (
          orderNotCompleted ||
          ['fund', 'plan', 'crypto', 'cash'].indexOf(this.order.switch.switchBuyPosition.type) ===
            -1 ||
          this.positionNotCompleted(this.order.switch.switchBuyPosition)
        )
      if (this.createNewSpinOffBuyPosition)
        return (
          orderNotCompleted ||
          ['stock'].indexOf(this.order.spinOff.spinOffBuyPosition.type) === -1 ||
          this.positionNotCompleted(this.order.spinOff.spinOffBuyPosition)
        )
      return orderNotCompleted
    },
    createNewSwitchBuyPosition() {
      return (
        !this.editing &&
        !this.duplicating &&
        this.myTypeOrderModal === 'switch' &&
        this.order.switch.switchBuyPosition &&
        !this.order.switch.switchBuyPosition._id
      ) // si no tiene id, se esta creando una nueva
    },
    createNewSpinOffBuyPosition() {
      return (
        !this.editing &&
        !this.duplicating &&
        this.myTypeOrderModal === 'spinOff' &&
        this.order.spinOff.spinOffBuyPosition &&
        !this.order.spinOff.spinOffBuyPosition._id
      ) // si no tiene id, se esta creando una nueva
    },
  },
  watch: {
    typeOrderModal() {
      this.myTypeOrderModal = this.typeOrderModal
    },
    async createNewPosition() {
      if (this.createNewPosition) {
        this.$set(this, 'position', { customMarket: { eod: {} } })
      } else {
        this.position = null
      }
      this.errorCode = null
    },
    editItem: {
      handler() {
        if (this.editing || this.duplicating) {
          this.order = JSON.parse(JSON.stringify(this.editItem))
          this.position = JSON.parse(JSON.stringify(this.editItem.position))
        } else {
          this.resetForm()
        }
      },
      immediate: true,
      deep: true,
    },
    positionSearchPositions: {
      handler() {
        if (
          this.positionSearchPositions &&
          !this.editing &&
          !this.duplicating &&
          ORDER_TYPES_AUTOSELECT_BASECURRENCY_POS.indexOf(this.myTypeOrderModal) > -1
        ) {
          const baseCurrencyPos = this.positionSearchPositions.find(
            (elem) => elem.ticker === this.user.baseCurrency
          )
          if (baseCurrencyPos) this.$set(this, 'position', baseCurrencyPos)
        }
      },
      immediate: true,
    },
    order() {
      if (this.showPreviewCard) {
        this.debouncePreviewOrder()
      }
    },
    position() {
      if (this.showPreviewCard) {
        this.debouncePreviewOrder()
      }
    },
  },
  methods: {
    changeToMyTypeOrderModal(type) {
      this.myTypeOrderModal = type
    },
    resetForm() {
      this.$set(this, 'order', {
        broker: null,
        newBroker: null,
        switch: {},
        spinOff: {
          spinOffBuyPositionAllocation: 0,
        },
        commodityUnit: 'oz',
        deductible: true,
        fxActive: true,
      })
      this.$set(this, 'position', null)
      this.$set(this, 'myTypeOrderModal', this.typeOrderModal)
      this.loading = false
      this.dateMenu = false
      this.errorCode = null
      this.createNewPosition = false
      this.isPairRotated = false
      clearTimeout(this.debouncePreviewTimeout)
    },
    debouncePreviewOrder() {
      if (!this.position) return

      this.loadingDebouncePreview = true
      clearTimeout(this.debouncePreviewTimeout)
      this.debouncePreviewTimeout = setTimeout(async () => {
        const order = JSON.parse(JSON.stringify(this.order))
        this.prepareOrder({ order })
        const preview = await previewOrder({
          position: this.position,
          order,
          type: this.myTypeOrderModal,
        })
        this.preview = preview.data
        this.loadingDebouncePreview = false
      }, 1000)
    },
    async createPosition(position) {
      if (position._id) delete position._id

      if (!isPositionDerivative(position)) {
        delete position.derivativePositionType
      }

      // if (['fund', 'putOption', 'callOption'].indexOf(this.typeOrDerivativeType) > -1) {
      //   delete position.exchange
      // }
      if (['fund', 'putOption', 'callOption'].indexOf(position.type) > -1) {
        delete position.exchange
      }
      // if (['fund'].indexOf(this.typeOrDerivativeType) > -1) {
      //   delete position.country
      // }
      if (['fund'].indexOf(position.type) > -1) {
        delete position.country
      }

      if (!position.customDefaultDividendOriginRetentionPercent) {
        delete position.defaultDividendOriginRetentionPercent
      }
      if (!position.customDefaultDividendReturnPercent) {
        delete position.defaultDividendReturnPercent
      }

      if (!position.customMarket) position.customMarket = {}
      if (position.type === 'custom') position.customMarket.active = true
      else if (position.type === 'cash') position.customMarket.active = false
      if (!position.customMarket.active) delete position.customMarket.eod

      const response = await createPosition(position)
      position._id = response.data._id
    },
    prepareOrder({ order }) {
      if (this.position.type === 'cash' && this.position.ticker === this.user.baseCurrency)
        order.price = 1
      if (!this.order.comission) order.comission = 0
      if (!this.order.taxes) {
        order.taxes = 0
        order.taxesCurrency = this.position.currency
      }
      if (!this.order.destinationRetentionBaseCurrency) order.destinationRetentionBaseCurrency = 0
      if (!this.showExchangeRate || !this.order.customExchangeRate || !this.order.exchangeRate) {
        delete order.exchangeRate
        order.customExchangeRate = false
      } else {
        if (this.isPairRotated) {
          order.exchangeRate = 1 / order.exchangeRate
        }
      }

      if (
        [
          'buy',
          'bonus',
          'stakeReward',
          'drip',
          'sell',
          'switch',
          'spinOff',
          'brokerTransfer',
          'sharePremium',
          'scrip',
          'capitalIncrease',
          'optionBuy',
          'optionSell',
          'commission',
          'paidInterest',
          'interest',
          'interestRetention',
          'deposit',
          'withdrawal',
        ].indexOf(this.myTypeOrderModal) > -1 &&
        order.broker
      ) {
        order.broker = order.broker._id
      } else {
        delete order.broker
      }

      if (this.myTypeOrderModal === 'switch') {
        const switchBuyPositionId = get(order, 'switch.switchBuyPosition._id', null)
        if (switchBuyPositionId) order.switch.switchBuyPosition = switchBuyPositionId
        delete order.switch.switchBuyOrder
        delete order.switch.switchBuyPositionCurrency

        if (!order.switch.switchBuyExchangeRate) delete order.switch.switchBuyExchangeRate

        const switchBuyBrokerId = get(order, 'switch.switchBuyBroker._id', null)
        if (switchBuyBrokerId) order.switch.switchBuyBroker = switchBuyBrokerId
      } else {
        delete order.switch
      }

      if (this.myTypeOrderModal === 'spinOff') {
        const spinOffBuyPositionId = get(order, 'spinOff.spinOffBuyPosition._id', null)
        if (spinOffBuyPositionId) order.spinOff.spinOffBuyPosition = spinOffBuyPositionId
        delete order.spinOff.spinOffBuyOrder
        delete order.spinOff.spinOffRate
      } else {
        delete order.spinOff
      }

      if (this.myTypeOrderModal === 'brokerTransfer') {
        order.newBroker = order.newBroker._id
      } else {
        delete order.newBroker
      }

      if (
        ['sell', 'optionSell'].indexOf(this.myTypeOrderModal) > -1 ||
        (['interest', 'bonus'].indexOf(this.myTypeOrderModal) > -1 &&
          this.typeOrDerivativeType === 'cash')
      ) {
        order.destinationRetentionBaseCurrency = order.destinationRetentionBaseCurrency || 0
      } else {
        delete order.destinationRetentionBaseCurrency
      }

      if (
        !order.fxActive ||
        [
          'buy',
          'bonus',
          'stakeReward',
          'drip',
          'sell',
          'sharePremium',
          'scrip',
          'capitalIncrease',
          'optionBuy',
          'optionSell',
        ].indexOf(this.myTypeOrderModal) === -1 ||
        this.typeOrDerivativeType === 'cash' ||
        !this.showExchangeRate
      ) {
        delete order.autoFx
      }

      if (
        ['buy', 'bonus', 'stakeReward', 'drip', 'sell'].indexOf(this.myTypeOrderModal) > -1 &&
        this.typeOrDerivativeType === 'commodity' &&
        ['GC', 'SI', 'PL', 'PA'].indexOf(this.position.ticker) > -1 &&
        order.commodityUnit === 'gr'
      ) {
        // convert from gr to oz
        order.positionNumber = order.positionNumber / OZT_TO_GR_RATE
        order.price = order.price * OZT_TO_GR_RATE
      }

      return order
    },
    async saveOrder() {
      if (!this.editing && !this.duplicating && this.createNewPosition) {
        try {
          this.loading = true
          await this.createPosition(this.position)
        } catch (error) {
          this.errorCode = get(error, 'data.name', null)
          if (!this.errorCode) {
            this.$root.$snackbar.error({ text: this.$t('common.saveError') })
          } else {
            this.$refs.apiErrorAlert.scrollToError()
          }
          this.loading = false
          return
        }
        this.loading = false
      }

      if (this.createNewSwitchBuyPosition || this.createNewSpinOffBuyPosition) {
        try {
          this.loading = true
          if (this.createNewSwitchBuyPosition)
            await this.createPosition(this.order.switch.switchBuyPosition)
          if (this.createNewSpinOffBuyPosition)
            await this.createPosition(this.order.spinOff.spinOffBuyPosition)
        } catch (error) {
          this.errorCode = get(error, 'data.name', null)
          if (!this.errorCode) {
            this.$root.$snackbar.error({ text: this.$t('common.saveError') })
          } else {
            this.$refs.apiErrorAlert.scrollToError()
          }
          this.loading = false
          return
        }
        this.loading = false
      }

      let order = JSON.parse(JSON.stringify(this.order))
      order = this.prepareOrder({ order })

      const orderAttributes = {
        buy: [
          'date',
          'broker',
          'positionNumber',
          'price',
          'comission',
          'comissionCurrency',
          'taxes',
          'taxesCurrency',
          'customExchangeRate',
          'exchangeRate',
          'fxActive',
          'autoFx',
          'tags',
          'description',
        ],
        sell: [
          'date',
          'broker',
          'positionNumber',
          'price',
          'comission',
          'comissionCurrency',
          'destinationRetentionBaseCurrency',
          'taxes',
          'taxesCurrency',
          'customExchangeRate',
          'exchangeRate',
          'fxActive',
          'autoFx',
          'tags',
          'description',
        ],
        switch: [
          'date',
          'broker',
          'positionNumber',
          'price',
          'comission',
          'comissionCurrency',
          'customExchangeRate',
          'exchangeRate',
          'switch',
          'tags',
          'description',
        ],
        spinOff: [
          'date',
          'broker',
          'positionNumber',
          'comission',
          'comissionCurrency',
          'customExchangeRate',
          'exchangeRate',
          'spinOff',
          'tags',
          'description',
        ],
        split: ['date', 'positionNumber', 'price', 'tags', 'description'],
        brokerTransfer: ['date', 'broker', 'newBroker', 'tags', 'description', 'positionNumber'],
        sharePremium: [
          'date',
          'broker',
          'positionNumber',
          'price',
          'comission',
          'comissionCurrency',
          'customExchangeRate',
          'exchangeRate',
          'fxActive',
          'autoFx',
          'tags',
          'description',
        ],
        scrip: [
          'date',
          'broker',
          'positionQuantity',
          'positionNumber',
          'price',
          'comission',
          'comissionCurrency',
          'customExchangeRate',
          'exchangeRate',
          'fxActive',
          'autoFx',
          'tags',
          'description',
        ],
        capitalIncrease: [
          'date',
          'broker',
          'positionQuantity',
          'positionNumber',
          'price',
          'comission',
          'comissionCurrency',
          'customExchangeRate',
          'exchangeRate',
          'fxActive',
          'autoFx',
          'tags',
          'description',
        ],
        commission: [
          'date',
          'broker',
          'positionNumber',
          'price',
          'deductible',
          'tags',
          'description',
        ],
        paidInterest: ['date', 'broker', 'positionNumber', 'price', 'tags', 'description'],
        interest: [
          'date',
          'broker',
          'positionNumber',
          'price',
          'destinationRetentionBaseCurrency',
          'deductible',
          'fxActive',
          'tags',
          'description',
        ],
        interestRetention: [
          'date',
          'broker',
          'positionNumber',
          'price',
          'deductible',
          'tags',
          'description',
        ],
        deposit: ['date', 'broker', 'positionNumber', 'price', 'tags', 'description'],
        withdrawal: ['date', 'broker', 'positionNumber', 'price', 'tags', 'description'],
      }
      const editOrderAttributes = {
        buy: [
          'date',
          'positionNumber',
          'price',
          'comission',
          'comissionCurrency',
          'taxes',
          'taxesCurrency',
          'customExchangeRate',
          'exchangeRate',
          'fxActive',
          'autoFx',
          'tags',
          'description',
        ],
        sell: [
          'date',
          'positionNumber',
          'price',
          'comission',
          'comissionCurrency',
          'destinationRetentionBaseCurrency',
          'taxes',
          'taxesCurrency',
          'customExchangeRate',
          'exchangeRate',
          'fxActive',
          'autoFx',
          'tags',
          'description',
        ],
        switch: [
          'date',
          'positionNumber',
          'price',
          'comission',
          'comissionCurrency',
          'customExchangeRate',
          'exchangeRate',
          'switch',
          'tags',
          'description',
        ],
        spinOff: [
          'date',
          'positionNumber',
          'comission',
          'comissionCurrency',
          'customExchangeRate',
          'exchangeRate',
          'spinOff',
          'tags',
          'description',
        ],
        split: ['date', 'positionNumber', 'price', 'tags', 'description'],
        brokerTransfer: ['date', 'broker', 'newBroker', 'tags', 'description', 'positionNumber'],
        sharePremium: [
          'date',
          'positionNumber',
          'price',
          'comission',
          'comissionCurrency',
          'customExchangeRate',
          'exchangeRate',
          'fxActive',
          'autoFx',
          'tags',
          'description',
        ],
        scrip: [
          'date',
          'positionQuantity',
          'positionNumber',
          'price',
          'comission',
          'comissionCurrency',
          'customExchangeRate',
          'exchangeRate',
          'fxActive',
          'autoFx',
          'tags',
          'description',
        ],
        capitalIncrease: [
          'date',
          'positionQuantity',
          'positionNumber',
          'price',
          'comission',
          'comissionCurrency',
          'customExchangeRate',
          'exchangeRate',
          'fxActive',
          'autoFx',
          'tags',
          'description',
        ],
        commission: ['date', 'positionNumber', 'price', 'deductible', 'tags', 'description'],
        paidInterest: ['date', 'positionNumber', 'price', 'tags', 'description'],
        interest: [
          'date',
          'positionNumber',
          'price',
          'destinationRetentionBaseCurrency',
          'deductible',
          'fxActive',
          'tags',
          'description',
        ],
        interestRetention: ['date', 'positionNumber', 'price', 'deductible', 'tags', 'description'],
        deposit: ['date', 'positionNumber', 'price', 'tags', 'description'],
        withdrawal: ['date', 'positionNumber', 'price', 'tags', 'description'],
      }
      orderAttributes.bonus = [
        ...orderAttributes.buy,
        'destinationRetentionBaseCurrency',
        'deductible',
        'fxActive',
      ]
      editOrderAttributes.bonus = [
        ...editOrderAttributes.buy,
        'destinationRetentionBaseCurrency',
        'deductible',
        'fxActive',
      ]

      orderAttributes.stakeReward = orderAttributes.buy
      editOrderAttributes.stakeReward = editOrderAttributes.buy
      orderAttributes.drip = orderAttributes.buy
      editOrderAttributes.drip = editOrderAttributes.buy
      orderAttributes.optionBuy = orderAttributes.buy
      editOrderAttributes.optionBuy = editOrderAttributes.buy
      orderAttributes.optionSell = orderAttributes.sell
      editOrderAttributes.optionSell = editOrderAttributes.sell

      try {
        this.loading = true
        if (this.editing) {
          order = pick(order, editOrderAttributes[this.myTypeOrderModal])
          await editOrder({ _id: this.order._id, order, type: this.myTypeOrderModal })
        } else {
          order = pick(order, orderAttributes[this.myTypeOrderModal])
          order.position = this.position._id
          await createOrder({ order, type: this.myTypeOrderModal })
        }
        this.$emit('saved', { newPositionCreated: this.createNewPosition })
        this.closeModal()

        this.$root.$snackbar.success({ text: this.$t('common.saveOk') })

        gtag.pageview({
          pagePath: `/input/orders/${this.editing ? 'edit' : 'create'}/${
            this.myTypeOrderModal
          }/success`,
          pageTitle: `input|orders|${this.editing ? 'edit' : 'create'}|${
            this.myTypeOrderModal
          }|success`,
          pageContentGroup: 'modal',
        })
      } catch (error) {
        this.errorCode = get(error, 'data.name', null)
        if (!this.errorCode) {
          this.$root.$snackbar.error({ text: this.$t('common.saveError') })
        } else {
          this.$refs.apiErrorAlert.scrollToError()
        }

        if (this.createNewPosition) await deletePosition(this.position)
        if (this.createNewSwitchBuyPosition)
          await deletePosition(this.order.switch.switchBuyPosition)
        if (this.createNewSpinOffBuyPosition)
          await deletePosition(this.order.spinOff.spinOffBuyPosition)

        gtag.pageview({
          pagePath: `/input/${this.editing ? 'edit' : 'create'}/${this.myTypeOrderModal}/error`,
          pageTitle: `input|${this.editing ? 'edit' : 'create'}|${this.myTypeOrderModal}|error`,
          pageContentGroup: 'modal',
        })
      }
      this.loading = false
    },
    rotateExchangeRatePair() {
      if (this.order.exchangeRate) this.order.exchangeRate = 1 / this.order.exchangeRate
      this.isPairRotated = !this.isPairRotated
    },
  },
}
</script>

<style lang="scss">
#order-modal-card {
  .items-flex {
    display: flex;
  }

  h1.section-title {
    font-size: 15px;
    font-weight: 600;
    color: #313b5d;
  }
  .add-position-card {
    height: 160px;
    width: 160px;
    border-radius: 20px;
    cursor: pointer;
    font-size: 14px;
    line-height: 1.7;
    color: #2597fe;
    font-weight: 400;

    background-color: white;
    border: 1px solid #eeeeee;
    &:hover {
      background-color: #f7f8fb;
      border: 1px solid #999;
    }
  }
  .go-back-link {
    font-size: 15px;
    font-weight: 500;
  }
  .divider {
    border-color: #f7f8fb;
  }
  .order-modal-create-new-position {
    a {
      font-size: 14px;
    }
  }
  .order-modal-card-capital-info {
    font-size: 13px;
    a {
      text-decoration: none;
    }
    .v-alert__icon {
      margin-right: 5px;
    }
  }
  .switch-cash-info-alert {
    font-size: 13px;
    .v-alert__icon {
      margin-right: 5px;
    }
  }
  .preview-card {
    font-size: 13px;
    h1 {
      font-size: 13px;
      font-weight: 500;
    }
  }
}
#order-modal-card.theme--dark {
  h1.section-title {
    color: white;
  }
  .add-position-card {
    background-color: #323940;
    border: 1px solid #5b5b5b;
    &:hover {
      background-color: #3b444c;
      border: 1px solid #a5a5a5;
    }
  }
  .divider {
    border-color: #3b444c;
  }
}
</style>
